import React from "react";
import { PolyPlusBadge } from "elements";
import { LocalKeys, useTranslation } from "utilities/i18n";

export const PageTitle: React.FC<{
  titleKey: LocalKeys;
  subTitleKey?: string;
}> = ({ titleKey, subTitleKey }) => {
  const { t } = useTranslation();
  return (
    <div className="card title-card">
      {t(titleKey)}
      {subTitleKey && (
        <span className="secondary-title">
          {t("NOTIFICATION_TITLE_SUB", { subTitleKey })}
        </span>
      )}
      <div className="polyplus-badge ml-1">
        <PolyPlusBadge className="small" />
      </div>
    </div>
  );
};
